import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductTextInput,
    DeleteProductTextInput,
    ProductText,
    UpdateProductTextInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductTextService {
    private amplifyClient = generateClient();

    async getProductText(id: string): Promise<ProductText> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductText,
                    variables: {
                        id
                    }
                })
            ).data.getProductText;
            if (data) return data as ProductText;
        } catch (error) {
            console.error('Error finding ProductText:', error);
            return null;
        }
    }

    async listProductTexts(): Promise<ProductText[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductTexts
                })
            ).data.listProductTexts.items;
            if (data) return data as ProductText[];
        } catch (error) {
            console.error('Error finding ProductText:', error);
            return null;
        }
    }

    async productTextsByName(name: string): Promise<ProductText[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductTextsByName,
                    variables: {
                        name
                    }
                })
            ).data.ProductTextsByName.items;
            if (data) return data as ProductText[];
        } catch (error) {
            console.error('Error finding ProductText:', error);
            return null;
        }
    }

    async productTextsByStatus(status: string): Promise<ProductText[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductTextsByStatus,
                    variables: {
                        status
                    }
                })
            ).data.ProductTextsByStatus.items;
            if (data) return data as ProductText[];
        } catch (error) {
            console.error('Error finding ProductText:', error);
            return null;
        }
    }

    async createProductText(
        input: CreateProductTextInput
    ): Promise<ProductText> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductText,
                    variables: {
                        input
                    }
                })
            ).data.createProductText;
            if (productOption) return productOption as ProductText;
        } catch (error) {
            console.error('Error creating ProductText:', error);
            return null;
        }
    }

    async updateProductTextItem(
        input: UpdateProductTextInput
    ): Promise<ProductText> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductText,
                    variables: {
                        input
                    }
                })
            ).data.updateProductText;
            if (productOption) return productOption as ProductText;
        } catch (error) {
            console.error('Error updating ProductText:', error);
            return null;
        }
    }

    async deleteProductText(
        input: DeleteProductTextInput
    ): Promise<ProductText> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProductText,
                    variables: {
                        input
                    }
                })
            ).data.deleteProductText;
            if (date) return date as ProductText;
        } catch (error) {
            console.error('Error creating ProductText:', error);
            return null;
        }
    }
}
